'use client';

import { type FC, useState } from 'react';

import { EmailStep } from '@/app/[locale]/(not-authorized)/account/password-recovery/components/PasswordRecovery/components/EmailStep';
import { SuccessStep } from '@/app/[locale]/(not-authorized)/account/password-recovery/components/PasswordRecovery/components/SuccessStep';
import { useBoolean } from '@/hooks/use-boolean';

export const PasswordRecovery: FC = () => {
  const [email, setEmail] = useState('');
  const { value: isSuccess, setTrue: succeed } = useBoolean();

  return isSuccess ? (
    <SuccessStep email={email} />
  ) : (
    <EmailStep
      onSubmit={(email) => {
        setEmail(email);
        succeed();
      }}
    />
  );
};
